<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="用户名">
              <a-input v-model.trim="queryParam.username" placeholder />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="工号">
              <a-input v-model.trim="queryParam.workNo" placeholder />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <!--      <a-col :md="8" :sm="24">
            <a-form-item label="用户类型">
              <a-select v-model="queryParam.type" placeholder="请选择" >
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="1">厂内</a-select-option>
                <a-select-option value="2">厂外</a-select-option>
              </a-select>
            </a-form-item>
            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="启用状态">
                <a-select v-model="queryParam.used" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option value="1">启用</a-select-option>
                  <a-select-option value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="(!advanced && 8) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>

              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>

          <!--        <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
               <a @click="toggleAdvanced" style="margin-left: 8px">
                 {{ advanced ? '收起' : '展开' }}
                 <a-icon :type="advanced ? 'up' : 'down'"/>
               </a>
            </span>
          </a-col>-->
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleSave()">新增</a-button>
      <!-- <a-button style="margin-left: 8px" type="primary" @click="handleExport()">导出</a-button>-->
      <a-upload
        accept=".xls, .xlsx"
        :showUploadList="false"
        :action="config.importUserUrl"
        :data="param"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button style="margin-left: 8px" type="primary" icon="plus">导入</a-button>
      </a-upload>

      <a-button style="margin-left: 8px" type="primary" @click="downLoad()">模板下载</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :pagination="{ pageSizeOptions: pageSizeOptionsList, showTotal: (total) => `共${total}条` }"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleReset(record)">重置密码</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleClearPassError(record)">清空密码错误次数</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <a-modal title="操作" style="top: 20px" :width="600" :confirmLoading="showLoading" v-model="visible" @ok="handleOk">
      <a-form :form="form">
        <a-form-item label="用户名" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder
            v-model="mdl.username"
            v-decorator="[
              'username',
              { initialValue: mdl.username, rules: [{ required: true, message: '请输入用户名' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="真实姓名" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder
            v-model="mdl.trueName"
            v-decorator="[
              'trueName',
              { initialValue: mdl.trueName, rules: [{ required: true, message: '请输入真实姓名' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="手机号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder
            v-model="mdl.phone"
            v-decorator="[
              'phone',
              {
                initialValue: mdl.phone,
                rules: [],
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item
          label="用户类型"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-select v-model="mdl.type" v-decorator="['type', { initialValue: mdl.type, rules: [{ required: true, message: '请选择用户类型'}]}]">
            <a-select-option value="">请选择</a-select-option>
            <a-select-option value="1">厂内</a-select-option>
            <a-select-option value="2">厂外</a-select-option>
          </a-select>
        </a-form-item>-->

        <a-form-item label="角色" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select
            :filterOption="filterOption"
            v-model="mdl.roleId"
            placeholder="请选择"
            v-decorator="['roleId', { initialValue: mdl.roleId, rules: [{ required: true, message: '请选择角色' }] }]"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in roleList" :key="index" :value="item.id">{{
              item.roleName
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="启用状态" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select
            v-model="mdl.used"
            defaultValue="1"
            v-decorator="['used', { initialValue: mdl.used, rules: [{ required: true, message: '请选择启用状态' }] }]"
          >
            <a-select-option value="1">启用</a-select-option>
            <a-select-option value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          v-if="mdl.roleId === config.RoleType.SUPPLIER"
          label="供应商"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select :filterOption="filterOption" v-model="mdl.corpSupplierId" placeholder="请选择">
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in corpSupplierSelect" :key="index" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item
          label="部门"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
          placeholder="请选择"
        >
          <a-select v-model="mdl.deptId" >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option :value="1">采购</a-select-option>
            <a-select-option :value="2">销售</a-select-option>
          </a-select>
        </a-form-item>-->

        <a-form-item label="工号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input placeholder v-model="mdl.workNo" />
        </a-form-item>

        <a-form-item label="身份证号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input placeholder v-model="mdl.idcard" />
        </a-form-item>
        <a-form-item label="联系地址" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-textarea placeholder v-model="mdl.address" />
        </a-form-item>
        <a-form-item label="邮箱" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder
            v-model="mdl.email"
            v-decorator="[
              'email',
              {
                initialValue: mdl.email,
                rules: [
                  {
                    type: 'email',
                    message: '不是有效的E-mail!',
                  },
                  {
                    required: false,
                    message: 'Please input your E-mail',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

import { STable } from '@/components'
import { getUserDelete, getUserPage, userSave, userResetPassWord, roleList, userExport } from '@/api/sys'
import { corpBusinessList, corpCompanyList, corpLogisticsList, getCorpSupplierList } from '@/api/basic'
import { formatDate } from '@/utils/date'
import { downloadUserUrl } from '@/utils/config.js'
import Bus from '@/layouts/bus'
export default {
  name: 'UserList',
  components: {
    STable
  },
  data() {
    return {
      showLoading: false,
      param: '',
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,
      form: this.$form.createForm(this),
      mdl: { used: '1' }, // 设置默认选中启用
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '编号',
          //dataIndex: 'id'
          scopedSlots: { customRender: 'serial' },

        },
        {
          title: '用户名',
          dataIndex: 'username'
        },
        {
          title: '角色',
          dataIndex: 'roleId',
          customRender: text => {
            return this.getRoleNameById(text)
          }
        },
        {
          title: '工号',
          dataIndex: 'workNo'
        },
        {
          title: '真实姓名',
          dataIndex: 'trueName'
        },
        {
          title: '手机号',
          dataIndex: 'phone'
        },
        {
          title: '联系地址',
          dataIndex: 'address'
        },
        {
          title: '启用状态',
          dataIndex: 'used',
          customRender: text => {
            return text === '1' ? '启用' : '禁用'
          }
        },
        {
          title: '创建时间',
          sorter: true,
          dataIndex: 'createTime',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 所属菜单下拉
      corpBusinessSelect: null,
      corpSupplierSelect: null,
      corpCompanySelect: null,
      corpLogisticsSelect: null,
      roleList: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getUserPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    // this.loadCorpBusinessSelect()
    // this.loadCorpLogisticsSelect()
    this.loadCorpSupplierSelect()
    this.loadRoleList()
    // this.loadCorpCompanySelect()
  },
  methods: {
    getRoleNameById(id) {
      for (let i = 0; i < this.roleList.length; i++) {
        let role = this.roleList[i]
        if (role.id === id) {
          return role.roleName
        }
      }
    },
    loadRoleList() {
      new Promise(resolve => {
        const data = roleList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.roleList = res
      })
    },
    loadCorpBusinessSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = corpBusinessList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpBusinessSelect = res
      })
    },
    loadCorpSupplierSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = getCorpSupplierList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        console.log(res)
        this.corpSupplierSelect = res
      })
    },
    loadCorpLogisticsSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = corpLogisticsList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpLogisticsSelect = res
      })
    },
    loadCorpCompanySelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = corpCompanyList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpCompanySelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
    },
    handleSave() {
      this.mdl = { used: '1' }
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.showLoading = true
          // 如果选择的角色是供应商,则必须选择供应商
          if (this.mdl.roleId === this.config.RoleType.SUPPLIER) {
            if (!this.mdl.corpSupplierId) {
              this.$message.warning('请选择供应商', 3)
              return
            }
          } else {
            // 清空供应商ID
            this.mdl.corpSupplierId = null
          }
          if (this.mdl.idcard) {
            if (!this.config.Regex.idCardNum.test(this.mdl.idcard)) {
              this.$message.warning('身份证格式错误', 3)
              return false
            }
          }
          userSave(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.visible = false
                this.$form.createForm(this)
                this.$refs.table.refresh()
              }
            })
            .catch(da => {
              console.log(da)
            })
            .finally(res => {
              console.log(res)
              this.showLoading = false
            })
        }
      })
    },
    handleClearPassError(record) {
      record["passErrorNum"] = 0
      userSave(record)
    },
    /* handleExport(){,
        userExport(this.queryParam)
          .then(res => {
            if (res.code === '0') {
              const token = Vue.ls.get(ACCESS_TOKEN)
              let fileName=res.data
              let url=this.config.downloadUserUrl
              url=url+fileName+'&accessToken='+token;
              window.location.href=url
            }
          }).catch((da) => {
          console.log(da)
        }).finally((res) => {
          console.log(res)
          this.confirmLoading = false
        })
      },*/

    downLoad() {
      let url = this.config.downLoadMouldUrl + '用户.xlsx'
      window.location.href = url
    },

    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return getUserDelete(Object.assign(record, nthis.queryParam))
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              nthis.confirmLoading = false
            })
        },
        onCancel() { }
      })
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        Bus.$emit('showSpinning', true, '准备导入...')
      }

      if (info.file.status === 'done') {
        Bus.$emit('showSpinning', false)
        if (info.file.response && info.file.response.code === '0') {
          this.$message.success('导入成功！')
          this.$refs.table.refresh()
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    beforeUpload(file) { },
    handleReset(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要重置密码吗?',
        onOk() {
          nthis.confirmLoading = true
          return userResetPassWord(Object.assign(record, nthis.queryParam))
            .then(res => {
              if (res.code === '0') {
                nthis.$message.success('重置密码成功')
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              nthis.confirmLoading = false
            })
        },
        onCancel() { }
      })
    },
    /*handleChange (value) {
        console.log('选择参数>>>' + value)
      },*/
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    checkPhone(rule, value, callback) {
      if (!value) return
      var re = this.config.Regex.telephone
      if (value.length == 11 && re.test(value)) {
        callback()
      } else {
        callback('不是有效的手机号')
      }
    }
  }
}
</script>


<style scoped>
/deep/ .ant-form-item {
  margin-bottom: 10px;
}
</style>